<div class="container-fluid reset-password">
  <div class="row h-100">
    <div class="col-lg-4 offset-lg-4 py-lg-5 py-4">
      <div class="right-section">
        <div class="right-section-content">
          <div class="onboarding-card d-md-block">
            <div class="text-center">
              <img src={{signupTick}} alt="">
              <h1 class="onboarding-card-title my-3">{{title}}</h1>
            </div>
            <div class="content text-center lh-24">
              <h4 class="text-center">Stay up to date with veterinary news.</h4>
              <a href="" routerLink="/login"
                 class="btn-outlined bg-black text-white my-4"  (click)="trackButtonClick('Login')">
                Login
              </a>
            </div>
          </div>

          <div class="d-md-block">
            <visit-products></visit-products>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
